import type { WriterFeatureFlags } from "./types";

// Writer is currently available by default. If rollout controls are needed later,
// they must come from a documented backend API instead of frontend environment or
// common-config conventions.
export const DEFAULT_WRITER_FEATURE_FLAGS = {
  agentEnabled: true,
  billingEnabled: true,
  entryEnabled: true,
  importEnabled: true,
} satisfies WriterFeatureFlags;
